module.exports = __webpack_public_path__ + "img/second-1.446dada0.webp";